var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.666 3.583a7.65 7.65 0 0 1-.899.575c.036.288.036.611.036.935 0 4.169-1.797 7.942-4.636 10.566-2.229 1.653-4.996 2.624-8.015 2.624A13.51 13.51 0 0 1 0 16.233a7.97 7.97 0 0 0 1.33.109c2.084 0 3.99-.719 5.499-1.905-1.941-.036-3.594-1.33-4.17-3.127.252.036.54.072.827.072.396 0 .755-.036 1.114-.144-.826-.18-1.545-.61-2.12-1.186A4.396 4.396 0 0 1 1.15 6.89v-.072c.54.287 1.114.467 1.761.539-.647-.503-1.186-1.186-1.473-1.977a4.734 4.734 0 0 1-.288-1.581c0-.216 0-.468.036-.683a4.778 4.778 0 0 1 .611-1.653c.323.359.683.718 1.078 1.078.18.18.396.323.575.503A14.676 14.676 0 0 0 7.152 5.2c.18.072.324.144.503.18.611.216 1.222.395 1.87.503.143.036.287.072.43.072.072 0 .108.036.18.036.288.036.54.072.827.108a4.89 4.89 0 0 1-.144-1.078c0-1.51.755-2.84 1.905-3.63a.58.58 0 0 1 .251-.144s.036 0 .036.036v-.036C13.693.852 14.448.6 15.31.6c1.294 0 2.444.54 3.271 1.438.288-.072.611-.144.899-.216.323-.108.61-.18.898-.323.36-.144.683-.324 1.006-.504a4.582 4.582 0 0 1-.826 1.474c-.252.287-.54.539-.827.79-.072.037-.144.108-.216.144h-.071v.036l.036-.036c.071 0 .143-.036.251-.036.324-.036.611-.107.935-.18.323-.071.646-.179.934-.287-.323.216-.647.431-.934.683z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.27af6f2e21e4eef9ab33ffc165827117.svg";
export { ForwardRef as ReactComponent };